import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getBanPsidInfo, setSelectedBan, setDwhParams, saveToHistory, setShowPopUp , resetState ,clearHistory} from './UpdateMailingMethodSlice';
import { stepEnum } from './Constant';
import BanSelection from './BanSelection';
import UpdateMailingMethod from './UpdateMailingMethod';
import UpdateMailingMessage from './UpdateMailingMessage';
import Popup from '../../Shared/Popup/PopUp';
import { gaInvoiceIntroPage } from './gaReports';

function MailingMethodMain(props) {

  useEffect(() => {
     getBansInfo();
     gaInvoiceIntroPage();

    return () => {
      props.resetState();
    }
   } , []);

  const getBansInfo = async () => {
    await props.getBanPsidInfo();
    props.setDwhParams({
      ...props.dwhParams,
      customerName: props.userDetails?.firstName + ' ' + props.userDetails?.lastName,
      idNumber: props.userDetails?.IDNumber,
      actionType:'Choosing invoicing address',
      });
  };
  let currentStep = () => {
    switch (props.currentStep) {
      case stepEnum.SELECT_BAN:
        props.saveToHistory('SelectBan');
        return <BanSelection content={props.iContent} />;

      case stepEnum.UPDATE_MAILING_METHOD:
        props.saveToHistory('Update');
        return <UpdateMailingMethod  content={props.iContent}/>;

      case stepEnum.UPDATE_STATUS_MESSAGE:
        props.clearHistory();
        return <UpdateMailingMessage />
    }

  };

  return <div className='UpdateMailingMethod'>
    {currentStep()}
    <Popup showPopUp={props.showPopup} onClose={() => props.setShowPopUp(false)}>
      <UpdateMailingMessage />
    </Popup>
  </div>;
}

const mapStateToProps = (state) => ({
  selectedBan: state.updateMailingMethod.selectedBan,
  currentStep: state.updateMailingMethod.currentStep,
  bansInfo: state.updateMailingMethod.bansInfo,
  messageContent: state.updateMailingMethod.messageContent,
  showPopup: state.updateMailingMethod.showPopup,
  dwhParams: state.updateMailingMethod.dwhParams,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  getBanPsidInfo,
  setSelectedBan,
  setDwhParams,
  saveToHistory,
  setShowPopUp,
  resetState,
  clearHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(MailingMethodMain);
